/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notificationcenter_Triggerunreadarialabel4Inputs */

const en_notificationcenter_triggerunreadarialabel4 = /** @type {(inputs: Notificationcenter_Triggerunreadarialabel4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notifications (${i?.count} unread)`)
};

/**
* | output |
* | --- |
* | "Notifications ({count} unread)" |
*
* @param {Notificationcenter_Triggerunreadarialabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_triggerunreadarialabel4 = /** @type {((inputs: Notificationcenter_Triggerunreadarialabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Triggerunreadarialabel4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_triggerunreadarialabel4(inputs)
});
export { notificationcenter_triggerunreadarialabel4 as "notificationCenter_triggerUnreadAriaLabel" }